import { observer } from 'mobx-react';
import React, { useCallback } from 'react';

import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { CircularProgress, IconButton } from '@mui/material';

import useStores from 'hooks/use-stores';
import { useCollectionArchiveImperative } from 'queries/archive/use-collection-archive-imperative';
import { useUserInfo } from 'queries/user-action/use-user-info';
import { downloadFile } from 'utils/download-file';
import Utils from 'utils/Utils';

import DownloadIcon from './assets/download.svg';
import useStyles from './styles';

interface Props {
    type: string;
    name: string;
    count: number;
    className?: string;
}

const BulletinWidget: React.FC<Props> = ({ type, name, count, className }) => {
    const { classes, cx } = useStyles();
    const { dialogStore } = useStores();

    const { data: user } = useUserInfo();
    const { mutate: fetchCollectionArchive, isPending, isError } = useCollectionArchiveImperative();

    const handleClick = useCallback(async () => {
        if (user) {
            fetchCollectionArchive({ type }, { onSuccess: (file) => downloadFile(file, file.name) });
        } else {
            dialogStore.openLoginDialog();
        }
    }, [dialogStore, fetchCollectionArchive, type, user]);

    return (
        <div className={cx(classes.container, className)}>
            <img width={48} height={48} className={classes.image} src={Utils.getImage(type)} alt={type} />
            <div className={classes.info}>
                <a href={'/search/types/' + type}>
                    <span className={classes.name}>{name}</span>
                </a>
                <span className={classes.count}>{`${count} entries`}</span>
            </div>
            <IconButton
                color={isError ? 'error' : 'inherit'}
                className={classes.button}
                disabled={isPending || isError}
                onClick={handleClick}
            >
                {isPending ? (
                    <CircularProgress size={16} />
                ) : isPending ? (
                    <ErrorOutlineOutlinedIcon />
                ) : (
                    <DownloadIcon />
                )}
            </IconButton>
        </div>
    );
};

export default observer(BulletinWidget);
